module.exports = __webpack_public_path__ + "img/026-management.d64106e7.svg";